import { Component } from "react";
import { graphql } from "gatsby";
import styles from "./show-block.module.less";
import UtilityArea from "components/block-elements/utility-area/utility-area";
import RichTextRenderer from "components/block-elements/rich-text-renderer/rich-text-renderer";
import { openOverlay } from "components/block-elements/overlay-link/overlay-link";
import { GlobalContext } from "components/stores/global-context";
import {
  DateHelper,
  SessionStorageHelper,
  extract,
  createDate,
  EventAggregator,
  ScheduleStore,
  isArray,
} from "@parksandresorts/core";
import animateScrollTo from "animated-scroll-to";

export default class ShowBlock extends Component {
  constructor(props) {
    super(props);
    this.title = extract(props, "title");
    this.preHeading = extract(props, "preHeading");
    this.preamble = extract(props, "preamble.preamble");
    this.contentRichText = extract(props, "content");
    this.backgroundMode = extract(props, "backgroundMode");
    this.contentfulId = extract(props, "contentful_id");
    this.mapLinkInternal = extract(props, "mapLink.internalLink.slug");
    this.mapLink = this.mapLinkInternal ? this.mapLinkInternal : extract(props, "mapLink.externalUrl");
    this.today = createDate();
    this.location = extract(props, "location");
    this.utilityDate = null;

    this._isMounted = false;

    this.productContentfulId = extract(props, "product.contentful_id");
    this.productPageSlug = extract(props, "product.productPageLink.slug");

    this.state = {
      utilityLoading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    ScheduleStore.getEventsForShowId(this.contentfulId)
      .then((events) => {
        if (!(events instanceof Array && events.length > 0)) {
          return;
        }

        if (events.length === 1) {
          this.utilityDate = events[0].startDateAndTime;
        } else {
          this.utilityDate = this.findNextEventDate(events);
        }

        if (this.utilityDate) {
          SessionStorageHelper.setItem("productDate", this.utilityDate, DateHelper.getTimestamp(5));
        }

        this.setState({ utilityLoading: false });
      })
      .catch(console.error);
  }

  findNextEventDate(events) {
    if (!(events instanceof Array && events.length > 0)) {
      return null;
    }
    const sortedUpcomingEvents = events
      .filter((event) => event.startDateAndTime > this.today)
      .sort((a, b) => {
        if (a.startDateAndTime < b.startDateAndTime) {
          return -1;
        }
        if (a.startDateAndTime > b.startDateAndTime) {
          return 1;
        }
        return 0;
      });

    return isArray(sortedUpcomingEvents) ? sortedUpcomingEvents[0].startDateAndTime : null;
  }

  onClickCTAButton() {
    if (!this.productContentfulId || !this.productPageSlug) {
      return;
    }

    const productElement = document.querySelector(`#id-${this.productContentfulId}`);
    if (productElement) {
      animateScrollTo(productElement, { verticalOffset: -64 });
    } else {
      openOverlay(this.productPageSlug, this.context);
    }

    EventAggregator.publish("trackEvent", { category: "Concert Page", action: "Clicked button", label: "Buy now" });
  }

  render() {
    return (
      <section className="block block--with-utility" data-contentful-id={this.props.contentful_id}>
        <div className={["block--max-width text--with-shadow", styles.outerWrapper].join(" ")}>
          <UtilityArea
            visible={!this.state.utilityLoading}
            location={this.location}
            nextShowTime={this.utilityDate}
            onClickButton={this.onClickCTAButton.bind(this)}
          />
          <div className={["block--max-width-narrow block--padded", styles.contentWrapper].join(" ")}>
            {this.preHeading && <h6 className={[styles.intro].join(" ")}>{this.preHeading}</h6>}
            {this.title && (
              <h1 className={[styles.title, !this.preHeading ? styles.title__extraMarginTop : ""].join(" ")}>
                {this.title}
              </h1>
            )}
            {this.preamble && <div className={["preamble", styles.preamble].join(" ")}>{this.preamble}</div>}
            {this.contentRichText && <RichTextRenderer richTextData={this.contentRichText} />}
          </div>
        </div>
      </section>
    );
  }
}

ShowBlock.contextType = GlobalContext;

export const fragmentShowBlock = graphql`
  fragment ShowBlock on ContentfulShowBlock {
    contentful_id
    node_locale
    id
    sortIndex
    preHeading
    title
    preamble {
      preamble
    }
    content {
      raw
      references {
        __typename
        ...ProductBlock
      }
    }
    label
    shortDescriptionInList
    pageLink {
      slug
    }
    imageInList {
      ...Asset
    }
    tags {
      title
    }
    length
    location
    product {
      contentful_id
      productPageLink {
        slug
      }
    }
    mapLink {
      ...Link
    }
  }
`;
